import PGPayments from './pg/payments';
import PGOrders from './pg/orders';
import PGRefunds from './pg/refunds';
import PGSuspicious from './pg/suspicious';
import PGSettlements from './pg/settlements';
import ImportsPgPayments from './imports/payments';
import ImportsPgOrders from './imports/orders';
import ImportsPgRefunds from './imports/refunds';
import ImportsPgSuspicious from './imports/suspicious';
import ImportPgSettlements from './imports/settlements';
import ImportPgPaymentVerification from './imports/paymentVerification';
import ImportPgReports from './imports/reports';

export const getTableConfig = ({
  page,
  isImportEnabled,
}: {
  page: string;
  isImportEnabled: boolean;
}) => {
  let configMapper;

  if (isImportEnabled) {
    configMapper = {
      PAYMENTS: ImportsPgPayments,
      ORDERS: ImportsPgOrders,
      REFUNDS: ImportsPgRefunds,
      SUSPICIOUS: ImportsPgSuspicious,
      SETTLEMENTS: ImportPgSettlements,
      PAYMENT_VERIFICATION: ImportPgPaymentVerification,
      REPORTS: ImportPgReports,
    };
  } else {
    configMapper = {
      PAYMENTS: PGPayments,
      ORDERS: PGOrders,
      REFUNDS: PGRefunds,
      SUSPICIOUS: PGSuspicious,
      SETTLEMENTS: PGSettlements,
    };
  }

  const config = configMapper[page];

  return config;
};
